module.exports = __webpack_public_path__ + "static/media/WonderUnitSans-500.927191bd.eot";